/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* designer-section-panel Component
*/
<template>
  <div class="designer-section-panel">
    <el-form
      ref="sectionForm"
      class="form-wrapper"
      label-position="top"
      :model="item"
      :rules="rules"
    >
      <el-form-item
        label="Nombre"
        prop="name"
      >
        <el-input
          ref="descriptionInput"
          v-model="item.name"
        />
      </el-form-item>
      <el-form-item
        label="Descripción"
        prop="description"
      >
        <wysiwyg v-model="item.description"/>
      </el-form-item>
      <el-form-item
        label="Ayuda"
        prop="helper"
      >
        <el-input v-model="item.helper"/>
      </el-form-item>
    </el-form>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormGroup from '@/components/forms/form-group'
import FormWrapper from '@/components/forms/form-wrapper'
import SectionModel from '../api/section.model'

export default {
  name: 'DesignerSectionPanel',
  components: { FormGroup, FormWrapper },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rules: SectionModel.rules
    }
  },
  watch: {
    item () {
      console.log('Question Descriptiono Focus')
      this.$refs.descriptionInput.focus()
    }
  },
  mounted () {
    console.log(this.$refs.sectionForm)
  },
  methods: {
    onUpdate (value) {
      this.$emit('update:item', value)
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
.designer-section-panel {
  .form-wrapper {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-section-panel.vue